import React from 'react'

export default function SmresetIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
            <path d="M5.5 9.5C7.975 9.5 10 7.475 10 5C10 2.525 7.975 0.5 5.5 0.5C3.025 0.5 1 2.525 1 5C1 7.475 3.025 9.5 5.5 9.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M4.22766 6.2832L6.77325 3.73762" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.77325 6.26238L4.22766 3.7168" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
